
import { Component, Vue, Watch } from "vue-property-decorator";
import MobileSectionStrip from "@/components/Common/Web/MobileSectionStrip.vue";
import menuService from "@/services/menu.service";

@Component({
  components: {
    MobileSectionStrip
  }
})
export default class Pagina extends Vue {
  private menu: any = "";
  private win = window;
  private menuLateral: any = [];
  private menuSectionLabel: string = "";
  private pagina: any = {
    id: "",
    titulo: "",
    nombre_web: "",
    fecha: "",
    banner: "",
    banner_mobile: "",
    contenido: "",
    direccion: "",
    telefono: "",
    email: "",
    horario: "",
    director: "",
    fecha_modificacion: "",
    tipo: "",
    estado: "",
    menu_lateral: "",
    tipo_responsable: "",
    redes_sociales: ""
  };
  private nombreWeb: any = "";
  private columnasTablaData = [
    {
      name: "nombre",
      label: "documento",
      align: "left"
    },
    {
      name: "dato",
      label: "Acción",
      align: "left"
    }
  ];
  private dataPagina: any = [];

  get muestraMenu() {
    if (
      this.pagina &&
      this.pagina.menu_lateral == 1 &&
      this.menuLateral.length > 0
    ) {
      return " col-xs-11 col-sm-11 col-md-8 col-lg-8 col-xl-8";
    }
    return " col-xs-11 col-sm-11 col-md-11 col-lg-11 col-xl-11";
  }

  private beforeMount() {
    if (
      this.$router.currentRoute.params.nombre &&
      this.$router.currentRoute.params.nombre != ""
    ) {
      this.nombreWeb = this.$router.currentRoute.params.nombre;
      this.getPagina();
    } else {
      this.routerGo("Home");
    }
  }
  private mounted() {}

  private getPagina() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("pagina?nombre_web=" + this.nombreWeb)
      .then((res: any) => {
        this.pagina = res.data;
        if (this.pagina.banner) {
          this.pagina.banner =
            process.env.VUE_APP_MEDIA_URL + "/" + this.pagina.banner;
        } else {
          this.pagina.banner =
            process.env.VUE_APP_MEDIA_URL + "/bannerPagina/default.jpg";
        }
        if (this.pagina.banner_mobile) {
          this.pagina.banner_mobile =
            process.env.VUE_APP_MEDIA_URL + this.pagina.banner_mobile;
        } else {
          this.pagina.banner_mobile =
            process.env.VUE_APP_MEDIA_URL + "/bannerPagina/default_mobile.jpg";
        }
        document.title =
          this.nombreWeb.replaceAll("-", " ") + " - Municipalidad de Maipú";
        // document.title = this.pagina.titulo + " - Municipalidad de Maipú";

        //MetaData generica
        (document.querySelector(
          'meta[name="description"]'
        ) as any).setAttribute("content", "Ilustre Municipalidad de Maipú");
        (document.querySelector('meta[name="image"]') as any).setAttribute(
          "content",
          this.pagina.banner_mobile
        );

        //MetaData Twitter
        (document.querySelector(
          'meta[name="twitter:title"]'
        ) as any).setAttribute(
          "content",
          this.nombreWeb.replaceAll("-", " ") + " - Municipalidad de Maipú"
        );
        (document.querySelector(
          'meta[name="twitter:description"]'
        ) as any).setAttribute("content", "Ilustre Municipalidad de Maipú");
        (document.querySelector(
          'meta[name="twitter:image:src"]'
        ) as any).setAttribute("content", this.pagina.banner_mobile);

        //MetaData Facebook
        (document.querySelector(
          'meta[property="og:title"]'
        ) as any).setAttribute(
          "content",
          this.nombreWeb.replaceAll("-", " ") + " - Municipalidad de Maipú"
        );
        (document.querySelector(
          'meta[property="og:description"]'
        ) as any).setAttribute("content", "Ilustre Municipalidad de Maipú");
        (document.querySelector(
          'meta[property="og:image"]'
        ) as any).setAttribute("content", this.pagina.banner_mobile);

        let tipo_responsable_label = "Director/a";
        if (this.pagina.tipo_responsable == 1) {
          tipo_responsable_label = "Director/a";
        } else if (this.pagina.tipo_responsable == 2) {
          tipo_responsable_label = "Encargado/a";
        } else if (this.pagina.tipo_responsable == 3) {
          tipo_responsable_label = "Coordinador/a";
        }
        if (this.pagina.director && this.pagina.director != "") {
          this.dataPagina.push({
            nombre: tipo_responsable_label,
            dato: this.pagina.director
          });
        }
        if (this.pagina.direccion && this.pagina.direccion != "") {
          this.dataPagina.push({
            nombre: "Dirección",
            dato: this.pagina.direccion
          });
        }
        if (this.pagina.email && this.pagina.email != "") {
          this.dataPagina.push({
            nombre: "Correo",
            dato: this.pagina.email
          });
        }
        if (this.pagina.telefono && this.pagina.telefono != "") {
          this.dataPagina.push({
            nombre: "Teléfono",
            dato: this.pagina.telefono
          });
        }
        if (this.pagina.horario && this.pagina.horario != "") {
          this.dataPagina.push({
            nombre: "Horario",
            dato: this.pagina.horario
          });
        }
        if (this.pagina.redes_sociales && this.pagina.redes_sociales != "") {
          this.dataPagina.push({
            nombre: "Redes Sociales",
            dato: this.pagina.redes_sociales
          });
        }
        this.setMenu();
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
        this.routerGo("Home");
      });
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }

  private llamar() {
    const numero = this.pagina.telefono;
    window.open("tel:" + numero);
  }

  private sendMail() {
    const correo = this.pagina.email;
    window.open("mailto:" + correo);
  }

  private irGoogleMaps() {
    window.open(
      "https://www.google.com/maps/search/?api=1&query=" + this.pagina.direccion
    );
  }

  private async setMenu() {
    this.menu = await menuService.getMenu();

    this.menuLateral = [];
    this.menuSectionLabel = "";

    if (this.pagina.menu_lateral == 1) {
      for (let i = 0; i < this.menu.length; i++) {
        if (this.getSubMenu(this.menu[i], this.pagina.nombre_web, 1)) {
          this.menuLateral = this.menu[i].sub_menu || [];
          this.menuSectionLabel = this.menu[i].nombre || "";
          this.checkSubMenus();
          break;
        }
      }
    }
  }

  private getSubMenu(element: any, nombre_web: string, profundidad) {
    if (element.nombre_web == nombre_web) {
      return true;
    } else {
      if (element.sub_menu && element.sub_menu.length > 0) {
        for (let j = 0; j < element.sub_menu.length; j++) {
          if (
            this.getSubMenu(element.sub_menu[j], nombre_web, profundidad + 1)
          ) {
            return true;
          }
        }
      }
      return false;
    }
  }

  private selectedStyle(item: any) {
    if (this.isSelectedMenuItem(item)) {
      item.expand = true;
      return " background-color: #10174a !important; color: white !important;font-family: 'RubikBold' !important;";
    }
    return "";
  }

  private isSelectedMenuItem(item: any) {
    if (this.$router.currentRoute.params.nombre == item.nombre_web) {
      return true;
    }
    if (item.sub_menu && item.sub_menu.length > 0) {
      for (let i = 0; i < item.sub_menu.length; i++) {
        if (
          this.$router.currentRoute.params.nombre == item.sub_menu[i].nombre_web
        ) {
          return true;
        }
      }
    }
    return false;
  }

  private checkSubMenus() {
    for (let i = 0; i < this.menuLateral.length; i++) {
      if (this.menuLateral[i].sub_menu.length > 0) {
        if (
          this.menuLateral[i].tipo == 2 &&
          this.$router.currentRoute.params.nombre ==
            this.menuLateral[i].nombre_web
        ) {
          this.menuLateral[i].expand = true;
        } else {
          for (let j = 0; j < this.menuLateral[i].sub_menu.length; j++) {
            if (
              this.menuLateral[i].sub_menu[j].nombre_web ==
              this.$router.currentRoute.params.nombre
            ) {
              this.menuLateral[i].expand = true;
              break;
            }
          }
        }
      } else {
        this.menuLateral[i].expand = false;
      }
    }
  }
  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open(item, target == 1 ? "_blank" : "_self");
    } else {
      return;
    }
  }
  private irMenuItem(item: any) {
    if (item.tipo == 1 || item.tipo == 2) {
      this.irPagina(item.nombre_web);
    } else if (item.tipo == 0) {
      this.toLink(item.url, item.blank);
    }
  }
  private irPagina(nombreWeb: any) {
    if (nombreWeb == "contacto") {
      this.routerGo("Contacto");
    } else if (nombreWeb == "concejo-municipal") {
      this.routerGo("Concejo");
    } else if (nombreWeb == "centros-de-atencion-municipal") {
      this.routerGo("Cam");
    } else if (nombreWeb == "oficinas-y-telefonos-municipales") {
      this.routerGo("Telefonos");
    } else if (nombreWeb == "boletines") {
      this.routerGo("Boletines");
    } else {
      if (nombreWeb && nombreWeb != "") {
        if (
          this.$router.currentRoute.name == "Pagina" &&
          this.$router.currentRoute.params.nombre &&
          this.$router.currentRoute.params.nombre == nombreWeb
        ) {
          this.$router.go(0);
        } else {
          if (this.$router.currentRoute.name == "Pagina") {
            if (
              this.$router.currentRoute.params.nombre &&
              this.$router.currentRoute.params.nombre != nombreWeb
            ) {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
              this.$router.go(0);
            } else {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
            }
          } else {
            this.$router
              .push({ name: "Pagina", params: { nombre: nombreWeb } })
              .catch(err => {
                console.log(err);
              });
          }
        }
      }
    }
  }
}
